import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex h-14 min-w-0 items-center justify-between gap-3 border-b border-slate-200 bg-white pl-14 pr-4 dark:border-slate-700 dark:bg-slate-900 md:px-4" }
const _hoisted_2 = { class: "min-w-0 truncate text-sm font-semibold text-slate-700 dark:text-slate-200" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "absolute -right-1 -top-1 min-w-4 rounded-full bg-red-600 px-1 text-center text-[10px] leading-4 text-white"
}

import { BellIcon, LogOutIcon } from "@lucide/vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'MainHeader',
  props: {
    userName: {},
    unreadNotifications: {}
  },
  emits: ["logout"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.userName), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        class: "relative inline-flex h-9 w-9 items-center justify-center rounded-md border border-slate-200 dark:border-slate-700",
        to: { name: 'notifications' },
        "aria-label": "Уведомления"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BellIcon), { class: "h-4 w-4" }),
          (__props.unreadNotifications)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.unreadNotifications > 99 ? '99+' : __props.unreadNotifications), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "inline-flex min-h-9 items-center gap-2 rounded-md border border-red-200 px-3 text-sm font-medium text-red-700 transition hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:cursor-not-allowed disabled:opacity-60 dark:border-red-900 dark:text-red-300 dark:hover:bg-red-950/40",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('logout')))
      }, [
        _createVNode(_unref(LogOutIcon), {
          class: "h-4 w-4",
          "aria-hidden": "true"
        }),
        _cache[1] || (_cache[1] = _createTextVNode(" Выйти ", -1))
      ])
    ])
  ]))
}
}

})